module.exports = __webpack_public_path__ + "static/media/24UHCHR2.c3ac6edc.jpg";